import { action } from 'satcheljs';
import type { ClientItemId } from 'owa-client-ids';

export interface OnMailServiceOpenItemActionMessage {
    clientItemId: ClientItemId;
}

const onMailServiceOpenItem: (clientItemId: ClientItemId) => OnMailServiceOpenItemActionMessage =
    action(
        'onMailServiceOpenItem',
        (clientItemId: ClientItemId): OnMailServiceOpenItemActionMessage => ({
            clientItemId,
        })
    );

export default onMailServiceOpenItem;
